import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config, secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';
export function stripHtmlFromString(html) {
  const tempElement = document.createElement('div');
  tempElement.textContent = html;
  return tempElement.textContent || '';
}

/*
 * NOTE
 * Adds text at the start of a tag
 * Accepts string parameter with tags in it
 * Will add text before other text in the tag
 *
 * EXAMPLE
 * > addText('@', "Hey <span data-test>Name</span>! <span>Great function</span>", 'span', 'data-test')
 * Will return
 * > "Hey <span data-test>@Name</span> <span>Great function</span>"
 *
 * NOTE
 * span with out the identifingAttribute was not changed
 */
export function addText(newText, htmlString, identifyingTag, identifyingAttribute) {
  const div = document.createElement('div');
  const sanitizedHtmlString = sanitizeHtml(htmlString, [identifyingTag]);
  div.innerHTML = sanitizedHtmlString;
  const childElements = div.getElementsByTagName(identifyingTag);
  for (let index = 0; index < childElements.length; index++) {
    const element = childElements[index];
    if (element.hasAttribute(identifyingAttribute)) {
      const textNode = document.createTextNode(newText);
      element.insertBefore(textNode, element.firstChild);
    }
  }
  return div.innerHTML;
}
function replaceNbspAndAmp(string) {
  return string.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
}
function recursiveDecodeHtmlEntities(input) {
  let decoded = input;
  let previous;
  let iterations = 0;
  const maxIterations = 5;
  while (iterations < maxIterations) {
    previous = decoded;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = previous;
    decoded = textarea.value;
    if (decoded === previous) break;
    iterations++;
  }

  // If we reach the max iterations, treat as unsafe and return an empty string
  return iterations === maxIterations ? '' : decoded;
}
export function sanitizeHtml(string, allowedTags) {
  const decodedString = recursiveDecodeHtmlEntities(string);
  const sanitizeConfig = allowedTags.length === 0 ? config.TEXTONLY : Object.assign({}, config.HTML, {
    elements: allowedTags,
    dom: secureDocument
  });
  const sanitizedText = sanitize(decodedString, sanitizeConfig);
  return replaceNbspAndAmp(sanitizedText);
}